import { render, staticRenderFns } from "./CleaningTypeForm.vue?vue&type=template&id=c0663776"
import script from "./CleaningTypeForm.vue?vue&type=script&lang=js"
export * from "./CleaningTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports